// src/index.tsx

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootswatch/dist/flatly/bootstrap.min.css';
import './index.css';

import React from 'react';

import { createRoot } from 'react-dom/client';

import App from './App';

const rootElement = document.getElementById("root") as HTMLElement;
createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
